import { render, staticRenderFns } from "./BearbeiteAltbestaende.vue?vue&type=template&id=d4a7ead4&"
import script from "./BearbeiteAltbestaende.vue?vue&type=script&lang=js&"
export * from "./BearbeiteAltbestaende.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports